import { Alert, Clickable, P } from '@ahmdigital/ui';

import { SWISS_RE_TRANSFER_URL } from '../../constants';

const LifeInsuranceAlert = () => (
  <Alert level="info" analyticsLabel="Life insurance SwissRe alert" heading="Transfer Complete">
    <P>
      We’re pleased to advise that the transfer of Swiss Re Life & Health Australia Limited ABN 74 000 218 306, AFSL
      324908 (Swiss Re Life) direct life insurance business to Hannover Life Re of Australasia Ltd ABN 37 062 395 484,
      AFSL 530811 (Hannover) under Part 9 of the Life Insurance Act 1995 (Cth) was completed at 12:01am on 01 December
      2025.
    </P>
    <P>
      Further information on the transfer can be found at{' '}
      <Clickable to={SWISS_RE_TRANSFER_URL}>www.ahm.com.au/swissre-transfer</Clickable>
    </P>

    <P>If you have any questions about your life insurance policy, please feel free to contact us.</P>
  </Alert>
);

export default LifeInsuranceAlert;
